import React from 'react';

export const BgColorControl = ({ theme, density, bgColor, setBgColor, themeBgColor }) => {
  const c = theme.colors;
  const t = theme.typography || {};

  const isDefault = bgColor.toLowerCase() === '#000000';
  const isThemeBg = bgColor.toLowerCase() === (themeBgColor || '').toLowerCase();

  // Two-option pill: Default (black) vs Theme. Style mirrors the other
  // small TopBar affordances (rounded pill, themed border, label size).
  const baseBtn = {
    padding: '6px 12px',
    background: 'transparent',
    borderTop: `1px solid ${c.borderPrimary}`,
    borderRight: `1px solid ${c.borderPrimary}`,
    borderBottom: `1px solid ${c.borderPrimary}`,
    borderLeft: `1px solid ${c.borderPrimary}`,
    color: c.textSecondary,
    cursor: 'pointer',
    fontSize: density.typography.labelSize,
    fontFamily: t.fontFamily,
    transition: 'all 150ms ease',
  };
  const activeBtn = {
    background: c.bgHover || `${c.accent}22`,
    color: c.accentLight,
  };

  return (
    <div style={{ display: 'inline-flex' }}>
      <button
        onClick={() => setBgColor('#000000')}
        style={{
          ...baseBtn,
          ...(isDefault ? activeBtn : {}),
          borderTopLeftRadius: 999,
          borderBottomLeftRadius: 999,
          borderRight: 'none',
          borderTopRightRadius: 0,
          borderBottomRightRadius: 0,
        }}
      >Default</button>
      <button
        onClick={() => setBgColor(themeBgColor)}
        style={{
          ...baseBtn,
          ...(isThemeBg && !isDefault ? activeBtn : {}),
          borderTopRightRadius: 999,
          borderBottomRightRadius: 999,
          borderTopLeftRadius: 0,
          borderBottomLeftRadius: 0,
        }}
      >Theme</button>
    </div>
  );
};
